import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill"]

import { withDefaults } from 'vue';

interface IProps {
  color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DangerTriangleIcon',
  props: {
    color: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8.00902 2C8.68902 2 9.29768 2.35267 9.63502 2.94333L14.4257 11.3193C14.761 11.9053 14.759 12.6047 14.4197 13.1893C14.0803 13.7747 13.4743 14.124 12.799 14.124H3.21035C2.53435 14.124 1.92835 13.7747 1.58902 13.1893C1.24968 12.6047 1.24768 11.9053 1.58302 11.3193L6.38302 2.942C6.72035 2.352 7.32835 2 8.00902 2ZM8.00835 3C7.69102 3 7.40835 3.164 7.24968 3.43933L2.45102 11.816C2.29502 12.0893 2.29635 12.4153 2.45435 12.688C2.61235 12.9607 2.89502 13.124 3.21035 13.124H12.799C13.1137 13.124 13.3963 12.9607 13.5543 12.688C13.713 12.4153 13.7143 12.0893 13.557 11.816L8.76702 3.43933C8.60902 3.164 8.32635 3 8.00835 3ZM8.00382 10.3327C8.37248 10.3327 8.67048 10.6307 8.67048 10.9993C8.67048 11.368 8.37248 11.666 8.00382 11.666C7.63515 11.666 7.33382 11.368 7.33382 10.9993C7.33382 10.6307 7.62915 10.3327 7.99715 10.3327H8.00382ZM8.00248 6.376C8.27848 6.376 8.50248 6.6 8.50248 6.876V8.94267C8.50248 9.21867 8.27848 9.44267 8.00248 9.44267C7.72648 9.44267 7.50248 9.21867 7.50248 8.94267V6.876C7.50248 6.6 7.72648 6.376 8.00248 6.376Z",
      fill: _ctx.color || '#5528B5'
    }, null, 8, _hoisted_2)
  ]))
}
}

})